import { apiGet } from '@/shared/utils/requestBuilder';
import type { PlataformaStatusResponse } from '../../types/plataforma';

export const plataformaStatusService = {
  getStatus: async (): Promise<PlataformaStatusResponse> => {
    const response = await apiGet('/admin/platform/status');
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.error?.message ?? 'Erro ao carregar status da plataforma');
    }

    return data.data as PlataformaStatusResponse;
  },
};
